export enum EAmenity {
  bathroom = "bathroom",
  coffe_shop = "coffe_shop",
  restaurant = "restaurant",
  pharmacy = "pharmacy",
  wifi = "wifi",
  atm = "atm",
  shopping = "shopping"
}